<template>
    <div v-if="isShow">
        <div class="bg" @click="boxClick($event)"></div>
        <div class="boxdiv">
            <img class="imgtop" :src="url">
            <div :class="['blank1',isX?'blank1x':'']"></div>
            <div class="imgdiv">
                <div class="close" @click="closeClick"></div>
                <img class="img" :src="url">
            </div>
            <div class="label1">长按保存结果图</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: true
        },
        url: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isShow: this.show,
            isX: false,
        }
    },
    watch: {
        show(val) {
            // console.log('show', val)
            this.isShow = val
        },
        isShow(val) {
            // console.log('isShow', val)
            this.$emit('on-show-change', val)
        }
    },
    mounted() {
        this.isX = window.iphone8;
    },
    methods: {
        boxClick(e) {
            e.cancelBubble = true
        },
        closeClick() {
            this.isShow = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.bg {
    opacity: 0.5;
    background: #000000;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 199;
}
.imgtop {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 301;
}
.boxdiv {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 300;
    .close {
        width: px2rem(80);
        height: px2rem(80);
        background-image: url('../assets/close.png');
        background-size: px2rem(40) px2rem(40);
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: px2rem(-40);
        top: px2rem(-40);
        z-index: 399;
    }
    .blank1 {
        height: px2rem(80);
    }
    .blank1x {
        height: px2rem(120);
    }
    .imgdiv {
        width: px2rem(550);
        margin: auto;
    }
    .img {
        display: block;
        margin: auto;
    }
    .label1 {
        margin-top: px2rem(40);
        text-align: center;
        font-size: px2rem(32);
        color: #FFFFFF;
    }
}
</style>
